<template>
    <div v-if="movieData">
        <div v-if="movieData" class="hero is-backdrop" :style="`background-image:url(${backdropPath})`">
            <div class="hero-body">
                <div class="columns">
                    <div class="column is-4">
                        <div class="card" style="width:342px;margin-left:auto;margin-right:0.75em;">
                            <div class="card-image">
                                <figure class="image" style="width:342px;">
                                    <img width="342" :src="posterPath" :alt="movieData.Title">
                                </figure>
                            </div>
                        </div>
                    </div>
                    <div class="column">
                        <div class="content">
                            <h1 class="title is-2">{{movieData.TitleWithYear}}</h1>
                            <h2 class="subtitle is-4"><em>{{movieData.Tagline}}</em></h2>
                            <p>{{ new Date(movieData.ReleaseDate) | dateFormat('DD/MM/YYYY') }} | {{genreList}}</p>
                            <div class="summary">{{movieData.Overview}}</div>
                        </div>
                        <div class="content">
                            <div class="levels is-size-5">
                                <div class="level-left">
                                <div class="level-item">
                                    <div class="rating-box">{{round(movieData.RatingThrillterOverall)}}</div>
                                </div>
                                <div class="level-item">
                                    <div class="rating-box">{{movieData.RatingImdb}}</div>
                                </div>
                                <div class="level-item">
                                    <div class="rating-box">{{round(movieData.RatingThrillterNudity)}}</div>
                                </div>
                                <div class="level-item">
                                    <div class="rating-box">{{round(movieData.RatingThrillterViolence)}}</div>
                                </div>
                                <div class="level-item">
                                    <div class="rating-box">{{round(movieData.RatingThrillterFrightening)}}</div>
                                </div>
                                </div>
                            </div>
                        </div>
                        <div class="content">
                            <div v-if="movieData.ProvidersStream.length > 0" class="level">
                                <div class="level-left">
                                    <!-- <div class="level-item">Subs</div> -->
                                    <div v-for="provider in movieData.ProvidersStream" :key="provider.Url" class="is-size-7" style="padding:0 5px; text-align:center;">
                                        <img width="30" :src="provider.Icon" :alt="provider.Title">
                                    </div>
                                </div>
                            </div>
                            <div v-if="movieData.ProvidersRent.length > 0" class="level">
                                <div class="level-left">
                                    <!-- <div class="level-item">Rent</div> -->
                                    <div v-for="provider in movieData.ProvidersRent" :key="provider.Url" class="is-size-7" style="padding:0 5px; text-align:center;">
                                        <img width="30" :src="provider.Icon" :alt="provider.Title">
                                        <br/>{{changeCurrency(provider.Price)}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="content video-list">
                            <p v-for="v in movieData.Videos.Results" :key="v.Id"><a href="#" @click.prevent="$emit('show-video', v.Key)"><i class="fab fa-youtube"></i>&nbsp;&nbsp;<span class="video-title">{{v.Name}}</span></a></p>
                        </div>
                    </div>
                    <div class="column is-1">
                        <a href="#" class="button is-info" @click="back">
                            <span class="icon">
                                <i class="fas fa-arrow-circle-left"></i>
                            </span>
                            <span>Back to search</span>                                    
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="movieData.Credits.Cast" class="section">
            <div class="columns">
                <div class="column is-1">&nbsp;</div>
                <div class="column">
                    <h2 class="subtitle is-4 has-text-light">Cast</h2>
                    <div class="columns is-multiline">                
                        <div v-for="castMember in castMembersWithPhotos" :key="castMember.Id" class="column is-2">
                            <div class="card has-background-grey-dark has-text-light">
                                <div class="card-image">
                                    <figure class="image">
                                    <router-link :to="`/?query=${castMember.Name}`">
                                        <img :src="`https://image.tmdb.org/t/p/w154${castMember.ProfilePath}`"/>
                                    </router-link>
                                    </figure>
                                </div>
                                <div class="card-content">
                                    <div class="content">
                                    <p class="title-with-year">
                                        <router-link :to="`/?query=${castMember.Name}`">
                                        {{ castMember.Name }}
                                        </router-link>
                                    </p>
                                    </div>
                                </div>
                            </div>                        
                        </div>
                    </div>
                </div>
                <div class="column is-1">&nbsp;</div>
            </div>
        </div>
        <div v-if="similarMoviesWithPhotos.length > 0" class="section">
            <div class="columns">
                <div class="column is-1">&nbsp;</div>
                <div class="column">
                    <h2 class="subtitle has-text-light">Similar movies</h2>
                    <div class="columns is-multiline">
                        <div v-for="movie in similarMoviesWithPhotos" :key="movie.id" class="column is-2">
                            <div class="card has-background-grey-dark has-text-light" style="height:100%;">
                                <div class="card-image">
                                    <figure class="image">
                                        <router-link :to="`/movies/${movie.releaseYear}/${movie.slug}`">
                                            <img :src="`https://image.tmdb.org/t/p/w154${movie.posterPath}`"/>
                                        </router-link>
                                    </figure>
                                </div>
                                <!-- <div class="card-content">
                                    <div class="content">
                                    <p class="title-with-year">
                                        <router-link :to="`/movies/${movie.releaseYear}/${movie.slug}`">
                                            {{ movie.title }}
                                        </router-link>
                                    </p>
                                    </div>
                                </div> -->
                            </div>                        
                        </div>
                    </div>
                </div>
                <div class="column is-1">&nbsp;</div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>
<script>
import Footer from './Footer.vue';
import Trailer from './Trailer.vue';
export default {
    props: {
        releaseYear: String,
        slug: String,
        imageBaseUrl: String
    },    
    components: {
        Footer,
        Trailer
    },
    data() {
        return {
            movieData: null
        };
    },
    computed: {
        ytPlayer() {
            return this.$refs.youtube.player;
        },        
        castMembersWithPhotos: function() {
            if (this.movieData.Credits.Cast)
                return this.movieData.Credits.Cast.filter(c => c.ProfilePath);
            return [];            
        },
        similarMoviesWithPhotos: function() {
            var $this = this;
            if (this.movieData.Similar.Results)
                return this.movieData.Similar.Results
                    .map(sr => { 
                        const ry = new Date(sr.ReleaseDate).getFullYear();
                        const slug = $this.makeSlugForSimilar(sr.Title, ry, sr.Id);
                        return {
                            id: sr.Id,
                            posterPath: sr.PosterPath,
                            releaseYear: ry,
                            title: sr.Title,                            
                            slug: slug
                        };
                    })
                    .filter(sr => sr.posterPath && sr.releaseYear >= 1960 && sr.releaseYear <= 1999);
            return [];            
        },
        backdropPath: function() {
            if (this.movieData)
                return `${this.imageBaseUrl}w1920_and_h800_multi_faces${this.movieData.BackdropPath}`;
            return '';
        },
        posterPath: function() {
            if (this.movieData)
                return `${this.imageBaseUrl}w342${this.movieData.PosterPath}`;
            return '';
        },
        genreList: function() {
            if (this.movieData && this.movieData.Genres)
                return this.movieData.Genres.join(', ');
            return '';
        }
    },
    methods: {
        makeSlugForSimilar: function(title, releaseYear, id) {
            return `${title.replace(' ', '-')}-${releaseYear}-${id}`.toLowerCase();
        },
        back: function() {
            this.$router.go(-1);
        },
        playVideo(id) {
            this.ytPlayer.playVideo()
        },
        changeCurrency: function(val) {
            return val.replace('$', '£');
        },
        round(value) {
            return Math.round(value);
        },
    },
    created: function() {
        fetch(`/data/${this.releaseYear}/${this.slug}.json`)
        .then(response => response.json())
        .then(data => {
            this.movieData = data;
        });          
  }
}
</script>
<style scoped>
.hero-body {
    background-image: linear-gradient(to right, rgba(18.82%, 14.90%, 12.94%, 1.00) 150px, rgba(24.71%, 22.35%, 20.78%, 0.84) 100%);    
    color:#fff;
    background-repeat: no-repeat;
}
.is-backdrop {
    border-bottom: 1px solid rgba(21.76%, 18.63%, 16.86%, 1.00);
    background-position: right -200px top;
    background-size: cover;
    background-repeat: no-repeat;
}
.content h1, .content h2, .content h3 {
    color:#fff;
}
        /* .rating-box-list {
            display:flex;
            flex-direction:row;
            justify-content:center; 
            align-items:center;
            } */
    
        .rating-box {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 50px;
            height: 50px;
            margin:0 2px;
            border:3px solid pink;
            border-radius: 100%;
            }
.video-list a {
    color:#fff;
}

.video-list a span.video-title {
    text-decoration: underline;
}
</style>        